import normalizeParentThreadId from '@/lib/threads/normalizeParentThreadId.js';

const getThreadParentId = (thread = {}) => {
  return normalizeParentThreadId(thread?.parentThreadId || thread?.parent_thread_id || thread?.parent?.threadId || thread?.parent?.id);
};

export default getThreadParentId;
